import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationDE extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code') {
    super(/^\d{5}$/i, errorMessage);
  }
}
